export const slashingKeys = {
  base: ["slashing"],
  list: (params: Record<string, unknown>) => [...slashingKeys.base, "list", params],
};
